export default __webpack_public_path__ + "static/consistent-header-dropdown-menus-aa2f24df2a7ef0f0c17a2b5963e002fe.png";